import styled from "styled-components";

const HeaderWrapper = styled.div`
  .headerBack {
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    padding: 10px 20px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: -${props => (props.themeSetting.toolbarAlignValue === "above" && !props.mini ? props.drawerWidth : props.themeSetting.toolbarAlignValue === "above" && props.mini ? (props.miniDrawerWidth === props.drawerWidth ? "80px" : props.miniDrawerWidth) : "0px")};
    @media only screen and (max-width: 991.98px) {
      margin-left: 0px !important;
    }

    .drawer-handle-arrow {
      flex-shrink: 0;
      @media only screen and (max-width: 991.98px) {
        display: none;
      }
    }

    .mini-drawer-menu-icon {
      flex-shrink: 0;
      cursor: pointer;
      display: none;
      color: #0f172a;
      @media only screen and (max-width: 991.98px) {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      i {
        font-size: 20px;
      }
      .app-name {
        font-weight: 700;
        font-family: "Outfit", sans-serif;
        font-size: 16px;
      }
    }

    .header-search-wrap {
      flex: 1;
      max-width: 520px;
      position: relative;
      z-index: 40;
      @media only screen and (max-width: 767px) {
        display: none;
      }

      .header-search-icon {
        position: absolute;
        left: 14px;
        top: 50%;
        transform: translateY(-50%);
        color: #94a3b8;
        font-size: 14px;
        pointer-events: none;
        z-index: 1;
      }

      .header-search-clear {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        border: 0;
        background: transparent;
        color: #94a3b8;
        width: 28px;
        height: 28px;
        border-radius: 8px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        &:hover {
          color: #0f172a;
          background: #e2e8f0;
        }
      }

      .header-search-input {
        width: 100%;
        padding: 9px 40px 9px 40px;
        border: 1.5px solid #e2e8f0;
        border-radius: 10px;
        background: #f8fafc;
        font-size: 13px;
        color: #334155;
        outline: none;
        transition: all 0.2s ease;
        font-family: "Inter", sans-serif;
        &::placeholder {
          color: #94a3b8;
        }
        &:focus {
          border-color: #10b981;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.08);
        }
        &::-webkit-search-cancel-button {
          -webkit-appearance: none;
        }
      }

      .header-search-dropdown {
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% + 8px);
        background: #fff;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        box-shadow: 0 16px 40px rgba(15, 23, 42, 0.14);
        max-height: 420px;
        overflow: auto;
        padding: 6px;
      }

      .header-search-empty {
        padding: 14px 12px;
        font-size: 13px;
        color: #64748b;
        font-weight: 600;
      }

      .header-search-item {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        border: 0;
        background: transparent;
        text-align: left;
        padding: 10px 10px;
        border-radius: 8px;
        cursor: pointer;
        color: #0f172a;

        &--active,
        &:hover {
          background: #f1f5f9;
        }

        &__icon {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background: #ecfdf5;
          color: #059669;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 13px;
        }

        &__text {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        &__label {
          font-size: 13px;
          font-weight: 700;
          color: #0f172a;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &__sub {
          font-size: 11px;
          font-weight: 600;
          color: #64748b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &__type {
          flex-shrink: 0;
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: #94a3b8;
        }
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: auto;
      flex-shrink: 0;
    }

    .header-bell-wrap {
      position: relative;
    }

    .header-bell-btn {
      position: relative;
    }

    .header-bell-badge {
      position: absolute;
      top: 2px;
      right: 2px;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      border-radius: 999px;
      background: #ef4444;
      color: #fff;
      font-size: 9px;
      font-weight: 800;
      line-height: 16px;
      text-align: center;
      pointer-events: none;
    }

    .header-notifications-dropdown {
      position: absolute;
      right: 0;
      top: calc(100% + 8px);
      width: min(360px, calc(100vw - 24px));
      background: #fff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      box-shadow: 0 16px 40px rgba(15, 23, 42, 0.14);
      z-index: 50;
      overflow: hidden;
    }

    .header-notifications-dropdown__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 14px;
      border-bottom: 1px solid #f1f5f9;
      font-size: 13px;
      font-weight: 700;
      color: #0f172a;
    }

    .header-notifications-dropdown__refresh {
      border: 0;
      background: transparent;
      color: #2563eb;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
      padding: 4px 6px;
      border-radius: 6px;
      &:hover:not(:disabled) {
        background: #eff6ff;
      }
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .header-notifications-dropdown__empty {
      padding: 16px 14px;
      font-size: 12px;
      font-weight: 600;
      color: #64748b;
      line-height: 1.45;
    }

    .header-notifications-dropdown__list {
      list-style: none;
      margin: 0;
      padding: 6px;
      max-height: 320px;
      overflow: auto;
    }

    .header-notifications-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      border: 0;
      background: transparent;
      text-align: left;
      padding: 10px;
      border-radius: 8px;
      cursor: pointer;
      &:hover {
        background: #f1f5f9;
      }

      &__title {
        font-size: 13px;
        font-weight: 700;
        color: #0f172a;
        line-height: 1.3;
      }

      &__desc {
        font-size: 12px;
        font-weight: 500;
        color: #64748b;
        line-height: 1.35;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      &__time {
        font-size: 11px;
        font-weight: 600;
        color: #94a3b8;
      }
    }

    .header-notifications-dropdown__footer {
      padding: 8px 10px 10px;
      border-top: 1px solid #f1f5f9;
      display: flex;
      justify-content: center;
    }

    .header-notifications-dropdown__all {
      border: 0;
      background: transparent;
      color: #059669;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
      padding: 6px 10px;
      border-radius: 8px;
      &:hover {
        background: #ecfdf5;
      }
    }

    .header-user-info {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-right: 4px;
      @media only screen and (max-width: 767px) {
        display: none;
      }
      .user-name {
        font-size: 13px;
        font-weight: 700;
        color: #0f172a;
        line-height: 1.3;
        font-family: "Outfit", sans-serif;
      }
      .user-role {
        font-size: 11px;
        color: #64748b;
        line-height: 1.2;
        text-transform: capitalize;
      }
    }

    .top-header-profile-class {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 2px solid #e2e8f0;
      cursor: pointer;
      transition: border-color 0.2s ease;
      object-fit: cover;
      &:hover {
        border-color: #10b981;
      }
    }
  }
`;

export default HeaderWrapper;
